module.exports = __webpack_public_path__ + "img/cv-logo-muic.fe28b8f2.png";